import { SplitContainer } from '@weezevent/nacre';
import { React, useMemo, css, main, observer, useTranslation } from '../';
import Summary from './Summary';
import Stepper from './Stepper';
import OrderStep from './OrderStep';
import AttendeesStep from './AttendeesStep';
import QuotasExceeded from './QuotasExceeded';

const Steps = observer(() => {
    const { t } = useTranslation();
    const { selectedCount, premiumOptions, invitationsCount } = main;

    const invitationsQuotasAvailable = useMemo(() => {
        if (premiumOptions) {
            return true;
        }
        // If one of the two conditions returns false, invitations are locked,
        // and the organizer is advised to contact support team.
        // To goal here is to prevent organizers without premium options to use
        // The invitation's platform as a spam tool.
        return Boolean(invitationsCount.count_orga < 1000 && invitationsCount.count_event < 500);
    }, [invitationsCount, premiumOptions]);

    if (!invitationsQuotasAvailable) {
        return <QuotasExceeded />;
    }
    return (
        <SplitContainer className={css['summary-position']} size={'maxi'} additional={<Summary />} onlyDesktop rootId="add-attendees">
            <Stepper>
                <OrderStep
                    title={t('attendees.invitations.order.title')}
                    subtitle={t('attendees.invitations.order.subtitle')}
                    inactive={`${t('attendees.addAttendees.withTarif.nexttitle')}: ${selectedCount}`}
                />
                <AttendeesStep title={t('attendees.invitations.attendee.title')} subtitle={t('attendees.invitations.attendee.subtitle')} />
            </Stepper>
        </SplitContainer>
    );
});
export default Steps;
